import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ItemList } from '../../model';

/**
 * * Componente padrão com a lista de resultados para o campo de pesquisa do Apolo.
 */
@Component({
  selector: 'ui-search-result-list',
  templateUrl: './search-result-list.component.html',
  styleUrls: ['./search-result-list.component.scss']
})
export class SearchResultListComponent {

  /**
   * * Lista de resultados encontrados.
   */
  @Input() list: ItemList[] = [];

  /**
   * * Indica se o componente deve ser de multi-seleção (padrão: simples).
   */
  @Input() multiSelect: boolean = false;

  /**
   * * Evento a ser emitido ao selecionar algum item.
   */
  @Output() selectChangeEvent = new EventEmitter<ItemList[]>();

  constructor() { }

  onSelect(item: ItemList) {
    if (this.multiSelect) {
      item.selected = !item.selected;
    } else {
      const itemSelected = this.list.filter(listItem => listItem.selected === true)[0];

      if (itemSelected === item) {
        item.selected = !item.selected;
      } else {
        if (itemSelected !== undefined) {
          itemSelected.selected = false;
        }
        item.selected = !item.selected;
      }
    }

    const selectedItems = this.list.filter(iList => iList.selected === true);
    this.selectChangeEvent.emit(selectedItems);
  }
}
